import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { portfolioData } from "./mock";

function App() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleViewWork = () => {
    scrollToSection('projects');
  };

  const handleContact = () => {
    scrollToSection('contact');
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Header onContactClick={handleContact} />
        <Hero 
          data={portfolioData.hero} 
          onViewWork={handleViewWork}
          onContact={handleContact}
        />
        <About data={portfolioData.about} />
        <Skills data={portfolioData.skills} />
        <Projects data={portfolioData.projects} />
        <Experience data={portfolioData.experience} />
        <Testimonials data={portfolioData.testimonials} />
        <Contact data={portfolioData.contact} />
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
